/**
 * This mixin detect responsive on resize and can return states:
 * - is_mobile
 * - is_tablet
 * - is_mac
 * - is_mac_like
 * - is_ios
 */

export default {
  data() {
    return {
      document_width: 0,
      mobile_breakpoint: 768,
      tablet_breakpoint: 1024,
      small_screen_breakpoint: 1380,
      is_mobile: null,
      is_tablet: null,
      is_mac: false,
      is_mac_like: false,
      is_ios: false,
      is_small_screen: false,
    };
  },

  computed: {
    mobileClassName() {
      return this.is_mobile ? "type-mobile" : "type-desktop";
    },
  },

  methods: {
    checkDocumentWidth() {
      this.document_width = document.body.clientWidth;
      this.is_mobile = this.document_width < this.mobile_breakpoint;
      this.is_tablet = this.document_width < this.tablet_breakpoint;
      this.is_small_screen = this.document_width < this.small_screen_breakpoint;
    },
  },

  mounted() {
    this.checkDocumentWidth();
    window.addEventListener("resize", this.checkDocumentWidth);
    this.is_mac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    this.is_mac_like = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    this.is_ios = /(iPhone|iPod|iPad)/i.test(navigator.platform);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkDocumentWidth);
  },
};
